// import { hitowaConfig } from './hitowa/shared/providers/tenantConfig';

export interface TenantPublicPortalExpectation {
  unified: boolean;
}

/** Lightweight topology registry; it deliberately imports no shell/page code. */
//
// TẠM TẮT CỔNG GỘP (unified portal) — 26/08/2026
//
// Cổng gộp là vỏ ngoài của phần RBAC đang thử nghiệm: toàn bộ route
// `api/v1/portal/{site_type}/rbac/*` cùng `me/permissions`, `me/menu` chỉ sống trong nhánh
// `sso.portal-mode:unified` (backend/routes/tenant_portal_routes.php). Bật cổng gộp cho một tenant
// là chuyển cả tenant đó sang một màn đăng nhập duy nhất ở `/{site}`, và `/{site}/admin/login`,
// `/{site}/massager/login` biến mất (routes.tsx:148 và :209 điều hướng thẳng về `/{site}`).
//
// VÌ SAO TẮT. `hitowa` khai `unifiedPortal: true` nhưng `VITE_SSO_UNIFIED_PORTAL_PATHS` trên dev3
// bỏ trống, nên hai nguồn bất đồng và `resolvePublicPortalProfile()` fail-closed — người dùng vào
// `/hitowa/admin/login` chỉ thấy 「ポータル設定を確認できません。」. Phần màn hình của cổng gộp
// chưa sẵn sàng, nên tắt hẳn để `hitowa` chạy như `medix` (legacy split) thay vì kẹt ở trang lỗi.
//
// BẬT LẠI KHI RBAC SẴN SÀNG: bỏ comment khối dưới + dòng import đầu file, rồi đặt
// `VITE_SSO_UNIFIED_PORTAL_PATHS={"hitowa":"/hitowa"}` trong `.env` của frontend và build lại
// (biến này nướng vào bundle lúc build, restart không đủ). Hai nguồn phải khớp, nếu không sẽ lại
// rơi vào `invalid`. Test tương ứng ở `src/features/sso/publicPortalProfile.test.ts` cũng bỏ
// comment cùng lúc.
//
// Cổng gộp KHÔNG nằm trong BD SSO (đã rà cả 7 sheet; "unified" duy nhất ở đó là
// `SSO_UNIFIED_LOGIN_ENABLED`, một thứ hoàn toàn khác). `hitowaConfig.features.unifiedPortal` giữ
// nguyên `true` vì nó ghi lại ý định của tenant; chỗ quyết định là đúng bảng này.
export const tenantPublicPortalExpectations: Record<string, TenantPublicPortalExpectation> = {
  // [hitowaConfig.code]: {
  //   unified: hitowaConfig.features.unifiedPortal === true,
  // },
};
